import { render } from "./CeremonyCard.vue?vue&type=template&id=57af4594&scoped=true"
import script from "./CeremonyCard.vue?vue&type=script&lang=js"
export * from "./CeremonyCard.vue?vue&type=script&lang=js"

import "./CeremonyCard.vue?vue&type=style&index=0&id=57af4594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57af4594"]])

export default __exports__